export const LOGIN_ACTION_LOADING = "LOGIN_ACTION_LOADING";
export const LOGIN_ACTION_SUCCESS = "LOGIN_ACTION_SUCCESS";
export const LOGIN_ACTION_FAILURE = "LOGIN_ACTION_FAILURE";
export const LOGIN_ACTION_STATUS_RESET = "LOGIN_ACTION_STATUS_RESET";
export const LOGOUT_ACTION_LOADING = "LOGOUT_ACTION_LOADING";
export const LOGOUT_ACTION_SUCCESS = "LOGOUT_ACTION_SUCCESS";
export const LOGOUT_ACTION_FAILURE = "LOGOUT_ACTION_FAILURE";
export const LOGOUT_ACTION_STATUS_RESET = "LOGOUT_ACTION_STATUS_RESET";

// export const LOGIN

export const SET_PLANT_NAME_AND_ROLE = "SET_PLANT_NAME_AND_ROLE";